import "./index.css";
import React, { createRef } from "react";
import _ from "lodash";
import moment from "moment";
import Grid from "@material-ui/core/Grid";
import Firebase from "../../firebasehelper";
import { CurrencyOptions, TerritoryOptions } from "../../Constants/retailer";
import ConfirmationModal from "../ConfirmationModal";
import PremierImg from "../../assets/media/coins/dollar-coin.png";
import ShoppingImg from "../../assets/media/coins/percent-coin.png";
import { earnedFromChecklist } from "./constants";

class UserTokenLedgerModal extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      history: {},
      premier_total: 0,
      shopping_total: 0,
      entryToDelete: null,
    };
    this.deleteTokensRef = createRef();
  }

  loadSpendTokensHistory = async () => {
    const { brandName, user, setTotal } = this.props;

    Firebase.getTokenSpentHistory(brandName, user.id, async (token_history) => {
      const premier_history = await Firebase.getPremierTokensHistory(
        brandName,
        user.id
      );

      const history = [
        ...token_history.map((h) => ({ ...h, tokenType: "shopping" })),
        ...premier_history.map((p) => ({ ...p, tokenType: "premier" })),
      ].sort((a, b) => a.created.seconds - b.created.seconds);

      // TODO: found this unused code here - looks important?
      // const groupedByDate = _.groupBy(
      //   history.sort((a, b) => b.created.seconds - a.created.seconds),
      //   (obj) => moment(obj.created.toDate()).format("LL")
      // );

      // const tokensHistory = Object.keys(groupedByDate).reduce((prev, date) => {
      //   var spent = 0;
      //   var earned = 0;
      //   groupedByDate[date].forEach((obj1) => {
      //     if (obj1.amount > 0) {
      //       spent += obj1.amount;
      //     } else {
      //       earned += -obj1.amount;
      //     }
      //   });
      //   prev[date] = { spent, earned };
      //   return pr
      //   ev;
      // }, {});

      const shopping_total = token_history.reduce(
        (n, { amount }) => n + amount,
        0
      );
      const premier_total = premier_history.reduce(
        (n, { amount }) => n + amount,
        0
      );

      setTotal({ shopping_total, premier_total });
      this.setState({ shopping_total, premier_total, history });
    });
  };

  componentDidUpdate(prevProps) {
    const { user, addTokenState } = this.props;
    const { user: prevUser, addTokenState: prevTokenState } = prevProps;

    if (user !== prevUser || prevTokenState !== addTokenState) {
      this.setState({ history: {} });
      this.loadSpendTokensHistory();
    }
  }

  deleteTokenEntry = async (tokenEntry) => {
    const { user } = this.props;
    const { brandName } = this.props;

    try {
      // 1. delete token history
      await Firebase.deleteTokenEntry(brandName, user.id, tokenEntry);

      if (tokenEntry.tokenType === "shopping") {
        // 2. subtract deleted token amount from token balance
        let updatedTokenBalance = user.tokens - Math.abs(tokenEntry.amount);
        // prevent token balance to drop below 0
        updatedTokenBalance = updatedTokenBalance < 0 ? 0 : updatedTokenBalance;
        const updatedFields = { tokens: updatedTokenBalance };
        await Firebase.updateUserData(brandName, user.id, updatedFields);
      } else if (tokenEntry.tokenType === "premier")
        this.loadSpendTokensHistory();
    } catch (e) {
      console.error("deleteTokenEntry", e);
    }
  };

  shouldRenderDeleteBtn = (tokenEntry) => {
    const { adminType } = this.props;
    const isEcoAdmin = process.env.REACT_APP_USER === "admin";
    const isBrandSuperAdmin =
      adminType && adminType.toLowerCase() === "super admin";
    const wasEarnedFromChecklist = earnedFromChecklist[tokenEntry.type];
    const earnedFromClickinGetStarted = tokenEntry.type === "Started";

    if (wasEarnedFromChecklist || earnedFromClickinGetStarted) return false;
    if (isEcoAdmin) return true;

    return isBrandSuperAdmin;
  };

  render() {
    const { user, territory, hex, white } = this.props;
    const { history, shopping_total, premier_total } = this.state;

    return (
      <div
        className="modal fade"
        id="list_user_token_ledgers"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="false"
        style={{ opacity: this.props.current === "user" ? 100 : 0 }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{user.firstname}'s token ledger</h5>
              <p>{user.id}</p>
            </div>
            <div className="modal-body pb-1" style={{ overflow: "auto" }}>
              {Object.keys(history || {}).map((date, index) => {
                return (
                  <div
                    key={index}
                    className="member-row"
                    title={
                      this.shouldRenderDeleteBtn(history[date])
                        ? ""
                        : "This token entry cannot be deleted"
                    }
                  >
                    <Grid container spacing={3}>
                      <Grid item xs={1} className="flex-row align-center">
                        <img
                          src={
                            history[date].tokenType === "shopping"
                              ? ShoppingImg
                              : PremierImg
                          }
                          alt="token"
                          style={{ width: "35px" }}
                        />
                      </Grid>
                      <Grid item xs={2} className="flex-row align-center">
                        <p className="member-name">
                          {moment
                            .unix(history[date].created.seconds)
                            .calendar(null, {
                              sameDay: "[Today]",
                              nextDay: "[Tomorrow]",
                              nextWeek: "dddd",
                              lastDay: "[Yesterday]",
                              lastWeek: "[Last] ddd",
                              sameElse: "DD.MM.YY",
                            })}
                        </p>
                      </Grid>
                      <Grid item xs={2} className="flex-row align-center">
                        <p className="member-name">
                          {`${history[date].amount <= 0 ? "+" : "-"} ${Math.abs(
                            history[date].amount
                          )}`}
                        </p>
                      </Grid>
                      <Grid item xs={2} className="flex-row align-center">
                        <p className="member-name">
                          {CurrencyOptions[territory || TerritoryOptions[0]]}
                          {(Math.abs(history[date].amount) / 100).toFixed(2)}
                        </p>
                      </Grid>
                      <Grid item xs={4} className="flex-row align-center">
                        <p className="member-name">
                          {history[date].type === "incremental task"
                            ? history[date].title
                            : history[date].type}
                        </p>
                      </Grid>
                      <Grid
                        item
                        xs={1}
                        className={`flex-row align-center token-ledger__close-btn-container ${
                          this.shouldRenderDeleteBtn(history[date])
                            ? ""
                            : "token-ledger__delete-btn--hidden"
                        }`}
                      >
                        <span
                          aria-hidden="true"
                          className="token-ledger__close-btn"
                          title="Delete this token entry"
                          onClick={() => {
                            this.setState({ entryToDelete: history[date] });
                            this.deleteTokensRef.current.click();
                          }}
                        >
                          &times;
                        </span>
                      </Grid>
                    </Grid>
                  </div>
                );
              })}
            </div>

            <div className="modal-footer">
              <img src={ShoppingImg} style={{ width: "35px" }} />
              <p>{`${shopping_total <= 0 ? "+" : "-"} ${Math.abs(
                shopping_total
              )}`}</p>
              <img src={PremierImg} style={{ width: "35px" }} />
              <p style={{ marginRight: "auto" }}>{`${
                premier_total <= 0 ? "+" : "-"
              } ${Math.abs(premier_total)}`}</p>
              <button
                type="button"
                className="btn btn-white btn-brand-hex"
                data-toggle="modal"
                data-target="#add_user_token_ledgers"
                onClick={() => this.props.setCurrent("add")}
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                  marginRight: 12,
                }}
              >
                Assign tokens
              </button>
              <button
                type="button"
                className="btn btn-white btn-brand-hex"
                data-dismiss="modal"
                style={{
                  "--hover-text-color": white ? "white" : "black",
                  "--hover-color": hex,
                  backgroundColor: "white",
                  color: "black",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
        <ConfirmationModal
          title="Are you sure you want to delete this token entry?"
          id="delete_tokens"
          onClick={() => this.deleteTokenEntry(this.state.entryToDelete)}
          hex={hex}
          white={white}
        />
        <button
          style={{ display: "none" }}
          ref={this.deleteTokensRef}
          data-toggle="modal"
          data-target="#delete_tokens"
        />
      </div>
    );
  }
}
export default UserTokenLedgerModal;



// WEBPACK FOOTER //
// ./src/components/UserTokenLedgerModal/index.js